<p-toast></p-toast>

<div class="resident-dashboard p-3">

  <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="min-height:300px;">
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
  </div>

  <ng-container *ngIf="!loading">

    <div class="page-title mb-4">
      <h3 class="m-0">Resident Portal</h3>
    </div>

    <!-- ── Section 1: Summary widgets ────────────────────────────────── -->
    <div class="row g-3 mb-4">
      <div class="col-12">
        <h4 class="fw-bold mb-1" style="color: var(--text-primary)">Your Tours</h4>
        <p class="mb-0" style="color: var(--theme-primary); font-size: 0.875rem">
          View upcoming tours and manage the times you're usually available.
        </p>
      </div>

      <div class="col-4">
        <div class="tour-stat-card tour-stat-card--active">
          <h2 class="tour-stat-card__number">{{ upcomingCount }}</h2>
          <span class="tour-stat-card__label">Upcoming Tours</span>
        </div>
      </div>

      <div class="col-4">
        <div class="tour-stat-card">
          <h2 class="tour-stat-card__number">{{ completedCount }}</h2>
          <span class="tour-stat-card__label">Completed Tours</span>
        </div>
      </div>

      <div class="col-4">
        <div class="tour-stat-card">
          <h2 class="tour-stat-card__number tour-stat-card__number--danger">{{ blackoutCount }}</h2>
          <span class="tour-stat-card__label">Blackouts (Admin+Tenant)</span>
        </div>
      </div>

      <div class="col-xxl-7">
        <div class="d-flex flex-column gap-3">
          <div class="upcoming-tours-card card">
            <div class="d-flex align-items-start justify-content-between mb-1">
              <div>
                <h5 class="fw-bold mb-1" style="color: var(--text-primary)">Upcoming Tours</h5>
                <p class="mb-0" style="color: var(--text-secondary); font-size: 0.85rem">
                  These are tours you've already accepted.
                </p>
              </div>
              <a routerLink="/followups" class="view-all-link">
                View All →
              </a>
            </div>

            <div class="tour-list mt-3">
              <div class="row gap-2">
                <div *ngFor="let tour of recentUpcomingTours" [ngClass]="recentUpcomingTours.length === 1 ? 'col-12' : 'col-md-6'">
                  <div class="tour-item h-100">
                <div class="tour-date-badge">
                  <span class="tour-date">{{ formatTourDate(tour.date, tour.time) }}</span>
                  <span class="tour-time">{{ formatTourTime(tour.date, tour.time) }}</span>
                </div>
                <div class="tour-info">
                  <p class="mb-1">
                    <span class="fw-semibold" style="color: var(--text-primary)">Prospect: </span>
                    <span class="tour-prospect-name">{{ tour.customer_name }}</span>
                  </p>
                  <p class="mb-0">
                    <span class="fw-semibold" style="color: var(--text-primary)">Interest: </span>
                    <span style="color: var(--text-secondary); font-size: 0.875rem">{{ tour.plan_name }}</span>
                  </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-center py-3" style="color: var(--text-muted); font-size: 0.875rem"
                  *ngIf="upcomingTours.length === 0">
                No upcoming tours scheduled.
              </div>
            </div>
          </div>
          <!-- Replace the p-card calendar block with this: -->
          <p-card styleClass="calendar-card">
            <ng-template pTemplate="header">
                <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 pb-2"
                    style="border-bottom: 1px solid #e9ecef;">
                  <div>
                    <h5 class="fw-semibold mb-1" style="color: var(--text-primary);">
                      Tours Calendar
                    </h5>
                    <p class="mb-0" style="font-size:12px; color:var(--text-secondary);">
                      Hover or click a dot to see tour details.
                    </p>
                  </div>
                  <div class="cal-legend">
                    <span class="cal-legend-item">
                      <span class="legend-dot dot-upcoming"></span> Upcoming
                    </span>
                    <span class="cal-legend-item">
                      <span class="legend-dot dot-completed"></span> Completed
                    </span>
                    <span class="cal-legend-item">
                      <span class="legend-dot dot-blackout"></span> Blackout
                    </span>
                  </div>
              </div>
            </ng-template>

            <div class="calendar-holder mt-2">
              <full-calendar [options]="calendarOptions"></full-calendar>
            </div>
          </p-card>
        </div>
      </div>
      <div class="col-xxl-5">
       <div class="weekly-availability-card card" [formGroup]="form">
        <h5 class="fw-bold mb-1" style="color: var(--text-primary)">Weekly Availability</h5>
        <p class="mb-3" style="color: var(--text-secondary); font-size: 0.85rem">
          Choose the days and times you're usually available for future tours.
        </p>

        <!-- <div class="mb-3">
          <label class="fw-semibold mb-1 d-block" style="font-size: 0.875rem">Select Time Zone</label>
          <p-dropdown [options]="timezones" [(ngModel)]="selectedTimezone"
            [ngModelOptions]="{standalone: true}"
            optionLabel="label" styleClass="w-50">
          </p-dropdown>
        </div> -->

        <div class="day-card" *ngFor="let day of days">
          <div class="day-card__header mb-2">

            <div class="day-checkbox"
                [class.day-checkbox--checked]="isAvailable(day)"
                [class.day-checkbox--disabled]="isLandlordDisabled(day)"
                (click)="!isLandlordDisabled(day) && form.get(day + '_available')?.setValue(!isAvailable(day))">
              <i class="pi pi-check" *ngIf="isAvailable(day)"></i>
            </div>

            <span class="day-card__name">{{ day }}</span>

            

            <span class="landlord-disabled-label ms-auto" *ngIf="isLandlordDisabled(day)">
              <i class="pi pi-lock me-1"></i>Not available
            </span>
            <span class="landlord-disabled-label normal-font ms-auto" *ngIf="!isLandlordDisabled(day)">
              <i class="pi pi-lock me-1"></i>Building Open To Tour
            </span>
          </div>

          <div class="d-flex align-items-start gap-3 flex-wrap flex-column">
            <div class="day-slots-summary ms-auto" *ngIf="!isLandlordDisabled(day)">
                <span class="slot-pill" *ngFor="let slot of getLandlordSlots(day)">
                  <i class="pi pi-clock"></i>
                  {{ slot }}
                </span>
            </div>
          <ng-container *ngIf="isAvailable(day) && !isLandlordDisabled(day)" [formArrayName]="day">
            <div class="day-card__slots">
              <div class="day-card__slot-row"
                  *ngFor="let slot of getSlots(day).controls; let j = index"
                  [formGroupName]="j">

                <p-dropdown formControlName="start"
                  [options]="landlordTimeOptions[day]"
                  optionLabel="label" optionValue="value"
                  placeholder="Start" styleClass="sm-dropdown-in-sm">
                </p-dropdown>

                <span class="slot-separator">to</span>

                <p-dropdown formControlName="end"
                  [options]="landlordTimeOptions[day]"
                  optionLabel="label" optionValue="value"
                  placeholder="End" styleClass="sm-dropdown-in-sm">
                </p-dropdown>

                <button class="slot-remove-btn" (click)="removeSlot(day, j)">×</button>
              </div>

              <button class="add-slot-btn" (click)="addSlot(day)">
                <span>+</span> Add another slot
              </button>
            </div>
          </ng-container>
          </div>
        </div>

        <div class="mt-3">
          <p-button label="Save Availability" icon="pi pi-save"
            [loading]="savingAvailability"
            (click)="saveAvailability()"
            class="primary-btn">
          </p-button>
        </div>
      </div>
      </div>
    </div>
    

  </ng-container>
</div>

<p-dialog header="{{editingBlackoutId ? 'Edit Blackout' : 'Add Blackout'}}"
  [(visible)]="showBlackoutDialog" [modal]="true" [closable]="true" [style]="{width:'360px'}">
  <div class="p-fluid">
    <div class="p-field mb-3">
      <label>Blackout Type</label>
      <p-dropdown [options]="blackoutTypes" [(ngModel)]="isFullDayBlackout"
        optionLabel="label" optionValue="value" placeholder="Select Type"></p-dropdown>
    </div>
    <div *ngIf="!isFullDayBlackout" class="mb-3">
      <label>Start Time</label>
      <p-calendar [(ngModel)]="blackoutStartTime" [timeOnly]="true" hourFormat="12"
        [stepMinute]="30" readonlyInput="true" inputmode="none" placeholder="From"></p-calendar>
      <label class="mt-2">End Time</label>
      <p-calendar [(ngModel)]="blackoutEndTime" [timeOnly]="true" hourFormat="12"
        [stepMinute]="30" readonlyInput="true" inputmode="none" placeholder="To"></p-calendar>
    </div>
    <div class="mb-3">
      <label>Reason</label>
      <input type="text" [(ngModel)]="blackoutReasonText" placeholder="Holiday / Maintenance" class="p-inputtext p-component w-100">
    </div>
  </div>
  <p-footer>
    <div class="d-flex justify-content-between gap-2 mt-2">
      <p-button *ngIf="editingBlackoutId" type="button" label="Delete"
        severity="danger" (click)="showDeleteBlackoutDialog(editingBlackoutId!)"></p-button>
      <div class="d-flex gap-2 ms-auto">
        <button pButton type="button" label="Cancel" class="p-button-secondary" (click)="showBlackoutDialog=false"></button>
        <button pButton type="button" label="Save" class="p-button-primary" (click)="saveBlackout()"></button>
      </div>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Confirm Delete" [(visible)]="showBlackoutDeleteDialog"
  [modal]="true" [closable]="false" [style]="{width:'350px'}">
  <p>Are you sure you want to delete this blackout?</p>
  <div class="d-flex justify-content-end gap-2 mt-3">
    <p-button label="No" (click)="cancelDeleteBlackout()"></p-button>
    <p-button label="Yes" severity="danger" (click)="confirmDeleteBlackout()"></p-button>
  </div>
</p-dialog>

<!-- Tour detail dialog -->
<!-- <p-dialog header="Tour Details" [(visible)]="showTourDialog" [modal]="true"
  [closable]="true" [style]="{width: '420px'}" [draggable]="false">
  <ng-container *ngIf="selectedTour">
    <div class="d-flex flex-column gap-2 p-1">
      <div><i class="pi pi-user me-2 text-muted"></i><strong>Customer:</strong> {{ selectedTour.customer_name }}</div>
      <div><i class="pi pi-envelope me-2 text-muted"></i><strong>Email:</strong> {{ selectedTour.customer_email }}</div>
      <div><i class="pi pi-phone me-2 text-muted"></i><strong>Phone:</strong> {{ selectedTour.phone_number }}</div>
      <div><i class="pi pi-home me-2 text-muted"></i><strong>Unit / Plan:</strong> {{ selectedTour.plan_name }}</div>
      <div><i class="pi pi-calendar me-2 text-muted"></i><strong>Date & Time:</strong> {{ formatTourDateTime(selectedTour.date, selectedTour.time) }}</div>
      <div><i class="pi pi-user-edit me-2 text-muted"></i><strong>Agent:</strong> {{ selectedTour.user_name || '—' }}</div>
      <div>
        <i class="pi pi-info-circle me-2 text-muted"></i><strong>Status:</strong>&nbsp;
        <p-tag [value]="selectedTour.status" [severity]="getStatusSeverity(selectedTour.status)"></p-tag>
      </div>
    </div>
  </ng-container>
  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" (click)="showTourDialog = false" class="primary-btn"></p-button>
  </ng-template>
</p-dialog> -->
